import reactUpdate from 'immutability-helper';

import {DataTable} from 'notebook/data-tables/DataTableConstants';
import {AddMenuItem} from 'notebook/data-tables/DataTableTypes';
import * as DataTableUtil from 'notebook/data-tables/DataTableUtil';
import {Table} from 'notebook/tables/TableConstants';

interface DataTableNoLinkContextProps {
  children: (args: {
    table: Table;
    sampleIds: Array<string> | null;
    addMenuItems: Array<AddMenuItem>;
  }) => JSX.Element;
  dataTable: DataTable;
  onUpdate: (dataTable: DataTable) => void;
}

const DataTableNoLinkContext: React.FC<DataTableNoLinkContextProps> = (
  props: DataTableNoLinkContextProps
): JSX.Element =>
  props.children({
    table: DataTableUtil.convertDataTableToTable(props.dataTable),
    sampleIds: null,
    addMenuItems: [
      {
        children: 'Add row',
        value: 'add-row',
        icon: 'compose',
        onSelect: () => {
          props.onUpdate(
            reactUpdate(props.dataTable, {
              rows: {
                $push: [
                  DataTableUtil.generateDataTableRow(props.dataTable.config, props.dataTable.rows.length, {}),
                ],
              },
            })
          );
        },
      },
    ],
  });

export default DataTableNoLinkContext;
